import { render } from "./ContinuePlayComponent.vue?vue&type=template&id=23ba03c4&scoped=true"
import script from "./ContinuePlayComponent.vue?vue&type=script&lang=ts"
export * from "./ContinuePlayComponent.vue?vue&type=script&lang=ts"

import "./ContinuePlayComponent.vue?vue&type=style&index=0&id=23ba03c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23ba03c4"

export default script